module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADQSURBVHgB7ZXvEcIgDMUfTtANrBt0BEdwAx1BJ/HcoJuoGzACG+gG+Dirh9Q/CLT9kt9dLqVtLg/CJYCQgbW2otWYAiZe0S72zh5jw6RH+8ocCcxQjgUSKCkgCREgAkTA5AKUv3DtlW5NqyJim+A/TbtGxGml1K73thssY7F95PVLELPrUlQ9ATwWQ3fA8Bha+8wbfuXxhLX9hBvBjbd2ddU/YtwdMdxszF35zptxvEQC0gdEgAgQATkCzt6z624nJKCQAbvfhq6mtd0sEf7mBgA7wntoJg8IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/add-icon-white.png
// module id = 1350
// module chunks = 1